// extracted by mini-css-extract-plugin
module.exports = {"TagLine":"LoginAdmin_TagLine__3hlSz","Highlight":"LoginAdmin_Highlight__nRO49","Row":"LoginAdmin_Row__2aRBQ"};